<template>
	<el-dialog
		:title="dialogTitle"
		:visible.sync="visible"
		width="520px"
		append-to-body
		@close="handleClose"
    class="custom-el-wrapper"
	>
		<el-form ref="form" :model="form" :rules="rules" label-width="90px">
			<el-form-item label="快递公司" prop="company_code">
				<el-select
					v-model="form.company_code"
					placeholder="请选择快递公司"
					filterable
					style="width: 100%;"
					:loading="companyLoading"
				>
					<el-option
						v-for="item in logisticsCompanyList"
						:key="item.code"
						:label="item.name"
						:value="item.code"
					/>
				</el-select>
			</el-form-item>
			<el-form-item label="运单号" prop="tracking_no">
				<el-input v-model="form.tracking_no" placeholder="请输入运单号" clearable />
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitting" @click="handleConfirm">确 认</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'ddDeliverDialog',
	data() {
		return {
			visible: false,
			mode: 'manual',
			targetItem: null,
			logisticsCompanyList: [],
			companyLoading: false,
			submitting: false,
			onSuccess: null,
			form: {
				company_code: '',
				tracking_no: '',
			},
			rules: {
				company_code: [{ required: true, message: '请选择快递公司', trigger: 'change' }],
				tracking_no: [{ required: true, message: '请输入运单号', trigger: 'blur' }],
			},
		}
	},
	computed: {
		dialogTitle() {
			return this.mode === 'edit' ? '修改运单' : '手动发货'
		},
	},
	methods: {
		openManual(item, onSuccess = null) {
			this.mode = 'manual'
			this.targetItem = item
			this.onSuccess = onSuccess
			this.resetForm(item)
			this.visible = true
			this.loadCompanies()
		},
		openEdit(item, onSuccess = null) {
			this.mode = 'edit'
			this.targetItem = item
			this.onSuccess = onSuccess
			this.resetForm(item)
			this.visible = true
			this.loadCompanies()
		},
		resetForm(item) {
			this.form = {
				company_code: '',
				tracking_no: item?.tracking_no || '',
			}
			this.$nextTick(() => {
				if (this.$refs.form) {
					this.$refs.form.clearValidate()
				}
			})
		},
		loadCompanies() {
			if (this.logisticsCompanyList.length > 0) {
				this.matchCompanyCode(this.targetItem)
				return
			}
			this.companyLoading = true
			this.$store.dispatch('ucenter_order/opOrderManageDdLogisticsCompanies', {
				success: (res) => {
					this.companyLoading = false
					if (res.code === 200) {
						this.logisticsCompanyList = Array.isArray(res.data?.logistics_company_list)
							? res.data.logistics_company_list
							: []
						this.matchCompanyCode(this.targetItem)
					}
				},
				fail: () => {
					this.companyLoading = false
				},
			})
		},
		matchCompanyCode(item) {
			if (!item || this.form.company_code || !item.logistics_company) {
				return
			}
			const name = String(item.logistics_company)
			const hit = this.logisticsCompanyList.find((c) => c.name === name || name.includes(c.name) || c.name.includes(name))
			if (hit) {
				this.form.company_code = hit.code
			}
		},
		handleConfirm() {
			if (!this.targetItem) {
				return
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return
				}
				const actionName = this.mode === 'edit'
					? 'ucenter_order/opOrderManageEditDdDeliverLogistics'
					: 'ucenter_order/opOrderManageManualDdDeliver'
				const payload = {
					id: this.targetItem.id,
					company_code: this.form.company_code,
					tracking_no: this.form.tracking_no,
				}
				this.submitting = true
				this.$store.dispatch(actionName, {
					data: payload,
					success: (res) => {
						this.submitting = false
						if (res.code === 200) {
							this.$message({ type: 'success', message: res.msg })
							this.visible = false
							if (typeof this.onSuccess === 'function') {
								this.onSuccess(res)
							}
						} else {
							this.$message({ type: 'error', message: res.msg || '操作失败' })
						}
					},
					fail: (res) => {
						this.submitting = false
						this.$message({ type: 'error', message: res?.msg || '操作失败' })
					},
				})
			})
		},
		handleClose() {
			this.visible = false
			this.submitting = false
		},
	},
}
</script>

<style scoped>
</style>
